import React from "react";
import { PODCAST_PLATFORMS, TV_PLATFORMS } from "../mock";
import BrandIcon from "./BrandIcon";

function formatUsers(str) {
  const m = str.match(/^([\d.]+)([MB])/);
  if (!m) return str.replace(' Users', '');
  return `${m[1]} ${m[2] === 'B' ? 'Billion' : 'Million'}`;
}

const ALL_PLATFORMS = [
  TV_PLATFORMS[0],  // iOS
  TV_PLATFORMS[1],  // Google Play
  TV_PLATFORMS[3],  // Android TV
  TV_PLATFORMS[5],  // Amazon Fire TV
  TV_PLATFORMS[8],  // Panasonic
  TV_PLATFORMS[6],  // Apple TV
  TV_PLATFORMS[7],  // LG webOS
  TV_PLATFORMS[4],  // Roku
  TV_PLATFORMS[10], // TCL
  TV_PLATFORMS[2],      // Samsung
  TV_PLATFORMS[11],     // Philips
  TV_PLATFORMS[9],      // Sony
  TV_PLATFORMS[12],     // Sharp
  TV_PLATFORMS[13],     // Amazon Appstore
  PODCAST_PLATFORMS[0], // Apple Podcasts
  PODCAST_PLATFORMS[1], // iHeart Radio
  PODCAST_PLATFORMS[2], // Spotify
  PODCAST_PLATFORMS[3], // Amazon Music
];

// A single cell: icon on dark bg top, stat on gold bg bottom — always paired
function PlatformCell({ platform, isPodcast }) {
  return (
    <div className="flex flex-col">
      {/* Icon area */}
      <div className="bg-[#080a10] flex items-center justify-center py-4 sm:py-6 md:py-8 flex-1">
        <BrandIcon
          slug={platform.slug}
          customIcon={platform.customIcon}
          color={platform.color}
          iconColor={platform.iconColor}
          name={platform.name}
          size={48}
          rounded="rounded-sm"
        />
      </div>
      {/* Stat area */}
      <div
        className="text-center py-3 sm:py-4 px-1"
        style={{ background: "linear-gradient(180deg, #fce181 0%, #f5c451 50%, #d6a836 100%)" }}
      >
        <div className="font-display text-[10px] sm:text-xs md:text-sm lg:text-base text-[#1a0f00] leading-tight">
          {formatUsers(platform.users)}
        </div>
        <div className="text-[6px] sm:text-[7px] md:text-[8px] tracking-[0.16em] uppercase text-[#1a0f00]/80 font-semibold mt-0.5">
          {isPodcast ? "Listeners" : "Viewers"}
        </div>
      </div>
    </div>
  );
}

function PlatformRow({ platforms }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-5 lg:grid-cols-9">
      {platforms.map((p) => {
        const isPodcast = PODCAST_PLATFORMS.some((pp) => pp.name === p.name);
        return (
          <div key={p.name} className="bg-transparent">
            <PlatformCell platform={p} isPodcast={isPodcast} />
          </div>
        );
      })}
    </div>
  );
}

export default function PlatformsShowcase() {
  return (
    <div className="relative mt-10 md:mt-14 max-w-6xl mx-auto px-2 md:px-0">
      <div className="rounded-md border border-white/10 bg-[#080a10] overflow-hidden flex flex-col">
        <PlatformRow platforms={ALL_PLATFORMS} />
      </div>
    </div>
  );
}
